module.exports = __webpack_public_path__ + "static/media/EdEraLogo.87eb152f.png";